module.exports = __webpack_public_path__ + "img/CHEVRON_RIGHT.41cbb1d7.svg";